/**
 * AUTH — re-exporta `@imobdesk/contracts`.
 * UX: reset de senha valida só password no form; token vem da URL.
 */
import { z } from 'zod'
import { auth } from '@imobdesk/contracts'

function formPayload(input: Record<string, unknown>): Record<string, unknown> {
  const payload: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(input)) {
    if (value !== null && value !== undefined) payload[key] = value
  }
  return payload
}

export const loginEmailPasswordFormSchema = auth.loginRequestSchema
export type LoginEmailPasswordForm = auth.LoginRequest

export const loginMagicLinkFormSchema = auth.loginMagicLinkRequestSchema
export type LoginMagicLinkForm = auth.LoginMagicLinkRequest

export const recuperarSenhaFormSchema = auth.newPasswordRequestSchema
export type RecuperarSenhaForm = auth.NewPasswordRequest

export const abrirContaFormSchema = auth.registerRequestSchema
export type AbrirContaForm = auth.RegisterRequest

export const validateOtpFormSchema = auth.validateOtpRequestSchema
export type ValidateOtpForm = auth.ValidateOtpRequest

export function mapLoginEmailPasswordFormToApiRequest(
  input: LoginEmailPasswordForm,
): auth.LoginRequest {
  return auth.loginRequestSchema.parse(formPayload(input as Record<string, unknown>))
}

export function mapLoginMagicLinkFormToApiRequest(
  input: LoginMagicLinkForm,
): auth.LoginMagicLinkRequest {
  return auth.loginMagicLinkRequestSchema.parse(
    formPayload(input as Record<string, unknown>),
  )
}

export function mapRecuperarSenhaFormToApiRequest(
  input: RecuperarSenhaForm,
): auth.NewPasswordRequest {
  return auth.newPasswordRequestSchema.parse(
    formPayload(input as Record<string, unknown>),
  )
}

export function mapAbrirContaFormToApiRequest(
  input: AbrirContaForm,
): auth.RegisterRequest {
  return auth.registerRequestSchema.parse(
    formPayload(input as Record<string, unknown>),
  )
}

export function mapValidateOtpFormToApiRequest(
  input: ValidateOtpForm,
): auth.CheckMagicLinkRequest {
  return auth.checkMagicLinkRequestSchema.parse({
    token: input.code,
    email: input.email,
  })
}

/** UX: PIN de 6 dígitos para drawers de confirmação OTP. */
export const otpPinFormSchema = z.object({
  pin: z
    .string()
    .length(6, 'PIN deve ter 6 dígitos')
    .regex(/^\d{6}$/, 'PIN deve conter apenas números'),
})

export type OtpPinForm = z.infer<typeof otpPinFormSchema>

export const confirmPasswordResetRequestSchema =
  auth.confirmPasswordResetRequestSchema

/** UX: token anexado na action a partir da rota, não do formulário. */
export const confirmPasswordResetFormSchema = z
  .object({
    password: z
      .string()
      .min(6, 'A senha deve ter no mínimo 6 caracteres')
      .max(18, 'A senha deve ter no máximo 18 caracteres')
      .regex(
        /^(?=.*[a-zA-Z])(?=.*\d)/,
        'A senha deve conter pelo menos 1 letra e 1 número',
      ),
    passwordConfirmation: z
      .string()
      .min(6, 'Confirme a senha')
      .max(18, 'Confirme a senha'),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: 'As senhas não conferem',
    path: ['passwordConfirmation'],
  })

export function mapConfirmPasswordResetFormToApiRequest(
  input: ConfirmPasswordResetForm,
  token: string,
): ConfirmPasswordResetRequest {
  return confirmPasswordResetRequestSchema.parse({
    token,
    password: input.password,
    passwordConfirmation: input.passwordConfirmation,
  })
}

export type ConfirmPasswordResetRequest = z.infer<
  typeof confirmPasswordResetRequestSchema
>
export type ConfirmPasswordResetForm = z.infer<
  typeof confirmPasswordResetFormSchema
>
